import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, ArrowRight } from "lucide-react";
import { PRODUCTS, PRODUCT_TIPS } from "../pages/products";

const INTERVAL_MS = 3 * 60 * 1000;
const FIRST_MS = 15 * 1000;
const SHOW_MS = 8 * 1000;

// Discreet landing notification. Mode 1: real authorized events (prop `events`, none fabricated).
// Mode 2 (default): informative product tips — never presented as other customers' activity.
export default function ProductTipPopup({ events = [] }) {
  const [item, setItem] = useState(null);
  const [idx, setIdx] = useState(0);
  const [muted, setMuted] = useState(() => sessionStorage.getItem("qora_tip_muted") === "1");

  useEffect(() => {
    if (muted) return;
    let hide;
    const show = () => {
      const pool = events.length ? events : PRODUCT_TIPS;
      setItem({ ...pool[idx % pool.length], real: events.length > 0 });
      setIdx((i) => i + 1);
      hide = setTimeout(() => setItem(null), SHOW_MS);
    };
    const first = setTimeout(show, FIRST_MS);
    const loop = setInterval(show, INTERVAL_MS);
    return () => { clearTimeout(first); clearInterval(loop); clearTimeout(hide); };
  }, [muted, events.length]); // eslint-disable-line

  if (!item || muted) return null;
  const p = PRODUCTS[item.product] || PRODUCTS.qr;
  const close = () => { setItem(null); };
  const mute = () => { sessionStorage.setItem("qora_tip_muted", "1"); setMuted(true); };

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:w-[360px] z-[60] fade-up" role="status" data-testid="product-tip-popup">
      <div className="rounded-2xl bg-white border border-border shadow-[0_18px_50px_-20px_rgba(12,45,52,0.45)] p-3.5 flex gap-3 items-start">
        <span className="h-10 w-10 rounded-xl grid place-items-center shrink-0" style={{ background: p.soft, color: p.accent }}><p.Icon className="h-5 w-5" /></span>
        <div className="flex-1 min-w-0">
          <p className="text-[10px] font-bold uppercase tracking-wider" style={{ color: p.accent }} data-testid="product-tip-kind">{item.real ? "Novità da Qora" : `${p.name} · Suggerimento`}</p>
          <p className="text-sm text-[#0c2d34] leading-snug mt-0.5" data-testid="product-tip-text">{item.text}</p>
          <div className="mt-2 flex items-center gap-3">
            <Link to={p.path} onClick={close} className="text-xs font-semibold inline-flex items-center gap-1 hover:underline" style={{ color: p.accent }}>Scopri <ArrowRight className="h-3 w-3" /></Link>
            <button onClick={mute} className="text-xs text-muted-foreground hover:text-foreground" data-testid="product-tip-mute">Non mostrare più</button>
          </div>
        </div>
        <button onClick={close} aria-label="Chiudi" className="h-7 w-7 grid place-items-center rounded-full hover:bg-muted text-muted-foreground shrink-0" data-testid="product-tip-close"><X className="h-4 w-4" /></button>
      </div>
    </div>
  );
}
